import FnrIcon from "UI/FnrIcon/FnrIcon";

import externalNavigate from "Utilities/externalNavigate";

import extendedFieldInputContainers from "../containers";

const { Info } = extendedFieldInputContainers;

const IigHelp = () => {
  const handleHelp = (e) => {
    e.stopPropagation();
    externalNavigate(
      "https://help.flocknote.com/article/236-what-is-intelligent-info-gathering"
    );
  };

  return (
    <Info onClick={handleHelp} data-cy="IIG_HelpLink">
      <FnrIcon icon="info-circle fas" />
    </Info>
  );
};

export default IigHelp;
